import React, { useEffect, useState } from "react";
import { BsFilterSquareFill } from "react-icons/bs";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, handleFormSubmit }) => {
  const handleToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [aoiSide, setAoiSide] = useState("");
  const [previousAOI, setPreviousAOI] = useState("");
  const [roofmaterial, setRoofmaterial] = useState("");
  const [minimumYearlyKwh, setMinimumYearlyKwh] = useState("");
  const [solarPanelNumberMin, setSolarPanelNumberMin] = useState("");
  const [dnoRating, setDnoRating] = useState("");
  const [ownershipCategory, setOwnershipCategory] = useState("");

  const roof_material_list = [
    "",
    "rooftile",
    "asphalt",
    "metal",
    "concrete, rooftile",
    "concrete",
    "concrete, metal",
    "asphalt, concrete, rooftile",
    "asphalt, concrete",
    "asphalt, eternit",
    "eternit",
    "concrete, eternit, metal",
    "asphalt, eternit, metal",
    "asphalt, rooftile",
    "metal, rooftile",
    "asphalt, metal",
    "eternit, rooftile",
    "asphalt, concrete, metal",
    "concrete, eternit",
    "eternit, metal",
  ];

  useEffect(() => {
    // how to set form data to state using javascript
    if (previousAOI != aoiSide) {
      setRoofmaterial("");
      setMinimumYearlyKwh("");
      setSolarPanelNumberMin("");
      setDnoRating("");
      setOwnershipCategory("");
    }

    setPreviousAOI(aoiSide);
  }, [aoiSide]);

  const submitForm = (e) => {
    e.preventDefault(); // Prevent default form submission
    const formData = new FormData(e.target);
    const areaOfInterest = formData.get("areaOfInterest");
    const roofMaterial = formData.get("roofMaterial");
    const minimumYearlyKwh = formData.get("minimumYearlyKwh");
    const solarPanelNumberMin = formData.get("solarPanelNumberMin");
    const dnoRating = formData.get("dnoRating");
    const ownershipCategory = formData.get("ownershipCategory");

    setAoiSide(areaOfInterest);
    setPreviousAOI(areaOfInterest);

    handleFormSubmit({
      areaOfInterest,
      roofMaterial,
      minimumYearlyKwh,
      solarPanelNumberMin,
      dnoRating,
      ownershipCategory,
    });
  };

  return (
    <div
      className={`p-4 transition-width duration-300 ${
        isSidebarOpen ? "w-14" : "w-96"
      }`}
    >
      <button onClick={handleToggle} className="mb-4 self-center">
        <BsFilterSquareFill />
      </button>
      {/* Conditional rendering based on isSidebarOpen state */}
      {!isSidebarOpen && (
        <div>
          <h2 className="mb-4 text-lg font-semibold">Filter Options</h2>
          <form onSubmit={submitForm}>
            <div className="mb-4">
              <label className="block mb-1">Area of Interest</label>
              <select
                name="areaOfInterest"
                className="w-full p-2 border border-gray-300 rounded"
                value={aoiSide}
                onChange={(e) => setAoiSide(e.target.value)}
              >
                <option value="Bournemouth, UK">Bournemouth, UK</option>
                <option value="Poole, UK">Poole, UK</option>
                <option value="Aylesbury, UK">Aylesbury, UK</option>
                <option value="Southampton, UK">Southampton, UK</option>
                <option value="Portsmouth, UK">Portsmouth, UK</option>
                <option value="Coventry, UK">Coventry, UK</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block mb-1">Roof Material</label>
              <select
                name="roofMaterial"
                className="w-full p-2 border border-gray-300 rounded"
                value={roofmaterial}
                onChange={(e) => setRoofmaterial(e.target.value)}
              >
                {roof_material_list.map((material, index) => (
                  <option key={index} value={material}>
                    {material}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block mb-1">System Size in kW</label>
              <select
                name="minimumYearlyKwh"
                className="w-full p-2 border border-gray-300 rounded"
                value={minimumYearlyKwh}
                onChange={(e) => setMinimumYearlyKwh(e.target.value)}
              >
                <option value=""></option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2000">2000</option>
                <option value="3000">3000</option>
                <option value="4000">4000</option>
                <option value="5000">5000</option>
              </select>
            </div>
            <div>
              <label className="block mb-1">Solar Panel Number (Min)</label>
              <select
                name="solarPanelNumberMin"
                className="w-full p-2 border border-gray-300 rounded"
                value={solarPanelNumberMin}
                onChange={(e) => setSolarPanelNumberMin(e.target.value)}
              >
                <option value=""></option>
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="150">150</option>
                <option value="200">200</option>
              </select>
            </div>

            <div>
              <h2 className="text-lg font-semibold mt-4">Advanced Filters</h2>
              <label className="block mb-1">DNO rating </label>
              <select
                name="dnoRating"
                className="w-full p-2 border border-gray-300 rounded"
                value={dnoRating}
                onChange={(e) => setDnoRating(e.target.value)}
              >
                <option value=""></option>
                <option value="Green">Green</option>
                <option value="Amber">Amber</option>
                <option value="Red">Red</option>
              </select>
            </div>
            <div>
              <label className="block mb-1">Ownership Category</label>
              <select
                name="ownershipCategory"
                className="w-full p-2 border border-gray-300 rounded"
                value={ownershipCategory}
                onChange={(e) => setOwnershipCategory(e.target.value)}
              >
                <option value=""></option>
                <option value="Private owner">Private owner</option>
                <option value="Company">Company</option>
                <option value="Housing Association">Housing Association</option>
                <option value="Council">Council</option>
                <option value="Corporate">Corportate</option>
              </select>
            </div>
            <button
              type="submit"
              className="w-full bg-[#2d9376] text-white py-2 px-4 rounded-lg hover:bg-green-600 mt-8"
            >
              Apply
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
